import React  from 'react'
import moment from 'moment'

import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid'
import listPlugin from '@fullcalendar/list'

import { OnSchedUtils } from '../../../utils'


const OnSchedFullCalendar = ({ element }) => {
  const { params, options } = element;
  
  const defaultView = OnSchedUtils.CalendarViews[options.defaultView?.toLowerCase()];
  const initialView = OnSchedUtils.IsEmpty(defaultView) ? 'resourceTimeGridDay' : defaultView;
  
  const [viewSelect, changeViewSelect] = React.useState(initialView);

  const viewChange = (e) => {
    console.log(e);
    OnSchedUtils.CalendarCustomEvents.ViewChange(e, element);
  }
  
  return (
    <FullCalendar
      plugins={[ dayGridPlugin, timeGridPlugin, interactionPlugin, resourceTimelinePlugin, resourceTimeGridPlugin, listPlugin ]}
      schedulerLicenseKey='CC-Attribution-NonCommercial-NoDerivatives'
      
      initialView={initialView}
      themeSystem='standard'
      timeZone={ params.timezoneName ? params.timezoneName : 'local'}
      navLinks={true}
      editable={true}
      dayMaxEventRows={3}
      dayMaxEvents={3}
      eventResourceEditable={true}
      refetchResourcesOnNavigate={false}
      nowIndicator={true}
      allDaySlot={false}
      weekends={options.hideWeekends ? !options.hideWeekends : true}
      firstDay={options.startWeekOnMonday ? true : false}
      dayPopoverFormat={{ month: 'short', day: 'numeric' }}
      fixedWeekCount={false}
      scrollTime={moment().format('hh:mm:ss')}
      eventConstraint="businessHours"
      customButtons={{ 
        refresh: { text: ' \u21ba	', click: () => calendar.refetchEvents() },
        customDay: { icon: 'calendar-day', click: () => calendar.refetchEvents() }
      }}

      viewDidMount={viewChange}
    />
  )
}

export default OnSchedFullCalendar
